import { jsx as p } from "react/jsx-runtime";
import { LabeledField as T } from "./index.es512.js";
import { forwardRef as U } from "react";
import { BaseInput as _ } from "./index.es677.js";
import { ChipInput as l } from "./index.es828.js";
const A = "unified-input-field", N = U(
  ({
    label: F,
    required: t,
    disabled: f,
    testId: m = A,
    feedback: c,
    isError: o = !1,
    asterix: e,
    value: r,
    infoTooltip: D,
    onChange: n,
    id: i,
    ...I
  }, a) => /* @__PURE__ */ p(
    T,
    {
      label: F,
      feedback: f ? [] : c,
      disabled: f,
      required: t,
      isError: o,
      asterix: e,
      testId: `${m}-label`,
      infoTooltip: D,
      id: i,
      children: Array.isArray(r) ? /* @__PURE__ */ p(
        l,
        {
          ...I,
          value: r,
          testId: m,
          "aria-disabled": f,
          isError: o,
          required: t,
          disabled: f,
          onChange: n,
          id: i,
          ref: a
        }
      ) : /* @__PURE__ */ p(
        _,
        {
          ...I,
          value: r,
          testId: m,
          isError: o,
          "aria-disabled": f,
          required: t,
          disabled: f,
          onChange: n,
          id: i,
          ref: a
        }
      )
    }
  )
);
export {
  A as UNIFIED_INPUT_FIELD_DEFAULT_TESTID,
  N as UnifiedInputField
};
//# sourceMappingURL=index.es62.js.map
